var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{attrs:{"rows":_vm.payload,"columns":_vm.columns,"busy":_vm.busy,"row-style-class":_vm.rowStyleClass},on:{"on-row-click":function (e) { return _vm.$emit('on-row-click', e); }}})}
var staticRenderFns = []

export { render, staticRenderFns }